import React, { useContext, useEffect, useState } from 'react';
import {
  IconButton,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography,
} from '@material-ui/core';
import { Archive, Delete, Edit } from '@material-ui/icons';

import moment from 'moment';

import PropTypes from 'prop-types';

import CustomCheckBox from '../../fields/customCheckBox';
import DeleteToolBar from '../../fields/deleteToolBar';
import SearchField from '../../fields/searchField';
import TablePaginationActions from '../../fields/tablePaginationActions';

import { filteredSearch, getComparator, getDataSheet, stableSort } from '../../../utils/helpers';

import { defaultRowsPerPage, defaultSortOrder, rowsPerPageOptions } from '../../../utils/constants';

import translations from '../../../languages/i18n';

import fieldStyles from '../../../styles/fieldStyles';
import { customOptionsTableStyles } from '../../../styles/formElementsStyles';

// import { SessionContext } from '../../../utils/context';

export default function PatientsListBasic({ administeredPrograms, patientsData, handleViewPatient, handleDelete, handleSelectedPatientsData, selectedPatients }) {
  const classesField = fieldStyles();
  const classesForm = customOptionsTableStyles();

  // const sessionContext = useContext(SessionContext);

  const [filteredUsers, setFilteredUsers] = useState(patientsData.slice());
  const [order, setOrder] = React.useState(defaultSortOrder); // Indica l'ordre per defecte
  const [orderBy, setOrderBy] = React.useState('username'); // Indica la columna per la que ordenam per defecte
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
  const [searchString, setSearchString] = useState('');

  useEffect(() => {
    setFilteredUsers(patientsData.slice());
    setSearchString('');
  }, [patientsData]);

  // Comprovam si el clínic que fa la consulta és administrador del programa al que està subscrit el pacient
  const administersProgram = (programId) => {
    return administeredPrograms.find((program) => program === programId);
  };

  const handleCheck = (id, username) => {
    handleSelectedPatientsData(id, username);
  };

  // const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const patientProgramsList = (enrolmentsArray) => {
    return (
      <React.Fragment>
        {enrolmentsArray.map((enrolment, index) => (
          <Typography key={`patProLis_${index}`} variant='body2'>
            {(administersProgram(enrolment.program._id) && (translations[enrolment.program.sharedId] ? translations[enrolment.program.sharedId].toUpperCase() : enrolment.program.name.toUpperCase())) || (translations[enrolment.program.sharedId] || enrolment.program.name)}
            <br />
          </Typography>
        ))}
      </React.Fragment>
    );
  };

  const searchPatient = (string) => {
    setPage(0);
    setSearchString(string);
    setFilteredUsers(filteredSearch(patientsData, string, ['username', 'enrolments']));
  };

  const patientsDataColumns = 5; // Per saber el nombre de propietats de cada objecte

  return (
    <TableContainer component={Paper}>
      <Table aria-label='patients list table'>
        <TableHead>
          <TableRow>
            {/* ATENCIÓ: si pintam la columna _id afegir 1 al colSpan */}
            <TableCell colSpan={patientsDataColumns +1} align='left' padding='none'>
              {(selectedPatients.length > 0 ? (
                <DeleteToolBar numSelected={selectedPatients.length} handleClick={handleDelete} />
              ) : (
                <Grid container direction='row' alignItems='center' justify='flex-start'>
                  <Grid item>
                    <SearchField handleChange={(string) => searchPatient(string)} value={searchString} />
                  </Grid>
                  <Grid item>
                    <IconButton style={{marginLeft: 60}} size='medium' onClick={() => getDataSheet(filteredUsers, ['username', 'enrolments', 'sex', 'birthdate'])}>
                      <Archive />
                    </IconButton>
                  </Grid>
                </Grid>
                ))}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow className={classesForm.tableRowHeaderBgColor}>
            {/* ATENCIÓ: no pintam la columna _id */}
            <TableCell align='left'>
              <TableSortLabel
                active={orderBy === 'username'}
                direction={orderBy === 'username' ? order : 'asc'}
                onClick={() => handleRequestSort('username')}
              >
                <strong>{translations['_username']}</strong>
              </TableSortLabel>
            </TableCell>
            <TableCell align='left'><strong>{translations['_programs']}</strong></TableCell>
            {/* <TableCell align='left'>
              <TableSortLabel
                active={orderBy === 'email'}
                direction={orderBy === 'email' ? order : 'asc'}
                onClick={() => handleRequestSort('email')}
              >
                <strong>{translations['_email']}</strong>
              </TableSortLabel>
            </TableCell> */}
            <TableCell align='left'><strong>{translations['_birthdate']}</strong></TableCell>
            <TableCell align='left'><strong>{translations['_sex']}</strong></TableCell>
            <TableCell align='center' />{/* Columna per al botó d'editar */}
            {/* <TableCell align='center'>{sessionContext.role === 'Admin' && <Delete className={classesField.iconBody} />}</TableCell> */}
            <TableCell align='center'><Delete className={classesField.iconBody} /></TableCell>
          </TableRow>
          {(rowsPerPage > 0
            // ATENCIÓ: l'ordenació es fa damunt filteredSchedules, si no s'ha introduit res al camp de cerca el filteredSchedules inclou tot el schedulesData,
            // és a dir, l'ordenació no es fa sobre la "pagina de formularis" que es mostra al llistat (estigui filtrada o no)
            ? stableSort(filteredUsers, getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : stableSort(filteredUsers, getComparator(order, orderBy))
          ).map((data, index) => (
            <TableRow key={data._id} className={index % 2 ? classesForm.tableRowBgColor1 : classesForm.tableRowBgColor2} hover>
              {/* ATENCIÓ: no pintam la columna _id */}
              {/* Només un Admin pot editar/veure la info d'un clí­nic */}
              <TableCell align='left'>{data.username}</TableCell>
              <TableCell align='left'>{data.enrolments !== null ? patientProgramsList(data.enrolments) : translations['_infoNotAvailable']}</TableCell>
              {/* <TableCell align='left'>{data.email}</TableCell> */}
              <TableCell align='left'>{data.birthdate && moment(data.birthdate).format('DD-MM-YYYY')}</TableCell>
              <TableCell align='left'>{data.sex && (data.sex === 'M' ? translations['_man'] : data.sex === 'W' ? translations['_woman'] : translations['_otherSex'])}</TableCell>
              <TableCell align='center'>
                <IconButton onClick={() => handleViewPatient(data._id)}>
                  <Edit />
                </IconButton>
              </TableCell>
              <TableCell align='center'>
                <CustomCheckBox
                  checked={selectedPatients.findIndex((item) => item.id === data._id) > -1} // Si res.value és dins la taula la condició dona true
                  onClick={() => handleCheck(data._id, data.username)}
                  // disabled={sessionContext.role !== 'Admin'} // Només l'administrador pot eliminar pacients
                  disabled={true} // Fins que no estigui programat al servidor la correcta eliminació de pacients, ho mantindrem deshabilitat
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              colSpan={patientsDataColumns + 2}
              count={filteredUsers.length}
              rowsPerPageOptions={rowsPerPageOptions}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              labelDisplayedRows={({ from, to, count }) => from + ' - ' + ((to !== -1 && to) || count) + ' ' + translations['_of'] + ' ' + ((count !== -1 && count) || (translations['_moreThan'] + ' ') + to)}
              labelRowsPerPage={translations['_rowsPerPage']}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
}

// Indica i controla els props que se han de passar al component
PatientsListBasic.propTypes = {
  administeredPrograms: PropTypes.array.isRequired, 
  handleViewPatient: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleSelectedPatientsData: PropTypes.func.isRequired,
  patientsData: PropTypes.array.isRequired,
  selectedPatients: PropTypes.array.isRequired,
};
